// i18n area 'tasks' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.da-DK.meta.json.
import type { enUS } from './tasks'

export const daDK: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Sammensatte operationer — kan genoptages fra det fejlede trin eller afbrydes',
    colType: 'Type',
    colTarget: 'Objekt',
    colPhase: 'Fase',
    colSteps: 'Trin',
    empty: 'Ingen macrotasks',
    detail: 'Detaljer',
    failedAt: 'fejlet ved',
    resume: 'Prøv igen fra det fejlede trin',
    abort: 'Afbryd det hele',
    cancel: 'Annuller',
    actionError: 'Handlingen blev afvist'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Søg efter type eller target',
    type: 'Type',
    target: 'Target',
    phaseLabel: 'Fase',
    progress: 'Fremdrift',
    started: 'Startet',
    finished: 'Afsluttet',
    node: 'Node',
    empty: 'Ingen tasks',
    loadError: 'Kunne ikke indlæse taskene — kan TVirt-backenden nås?',
    limboHint: "Noden '{node}' har ikke kunnet nås siden {time} — tasken holder write leasen på sit target, indtil noden vender tilbage eller attesteres slukket",
    nodeAttested: 'Node attesteret slukket',
    phase: {
      queued: 'I kø',
      running: 'Kører',
      succeeded: 'Fuldført',
      failed: 'Fejlet',
      cancelled: 'Annulleret',
      'failed-at-step': 'Fejlet ved et trin',
      aborted: 'Afbrudt'
    },
    dropdown: {
      tooltip: 'Tasks i gang',
      title: 'Tasks i gang',
      empty: 'Ingen tasks i gang',
      viewAll: 'Se alle tasks'
    },
    detail: {
      open: 'Detaljer',
      scope: 'Scope',
      message: 'Besked',
      params: 'Parametre',
      result: 'Resultat',
      errorTitle: 'Fejl',
      steps: 'Trin',
      failedAt: 'fejlet ved',
      superseded: 'overhalet',
      step: 'Trin',
      parent: 'Parent task',
      failedStep: 'Fejlet trin',
      log: 'Log',
      logEmpty: 'Ingen loglinjer endnu',
      close: 'Luk'
    },
    actions: {
      cancel: 'Annuller',
      resume: 'Prøv igen fra det fejlede trin',
      abort: 'Afbryd det hele (undo af de fuldførte trin)',
      refused: 'Handlingen blev afvist'
    }
  },
  events: {
    loadError: 'Journalen kunne ikke indlæses — er TVirt-backenden tilgængelig?',
    title: 'Hændelser',
    subtitle: 'Klyngens historiske hukommelse: fuldbyrdede kendsgerninger, nyeste først',
    filterSeverity: 'Alvorsgrad',
    filterCategory: 'Kategori',
    filterAll: 'Alle',
    searchLabel: 'Søg',
    searchPlaceholder: 'Søg i hele journalen',
    subjectFilter: 'Hændelser for {subject} — vis alle',
    colAt: 'Hvornår',
    colSeverity: 'Alvorsgrad',
    colType: 'Type',
    colSubject: 'Emne',
    colActor: 'Hvem',
    colNode: 'Node',
    colMessage: 'Besked',
    empty: 'Ingen hændelser',
    loadMore: 'Indlæs flere',
    actorSystem: 'system',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Hændelses-ID',
    taskCollectedHint: 'Task har kortere opbevaring: når den er indsamlet, svarer linket ikke længere',
    severity: {
      info: 'Info',
      warning: 'Advarsel',
      error: 'Fejl',
      critical: 'Kritisk'
    },
    category: {
      lifecycle: 'Livscyklus',
      config: 'Konfiguration',
      availability: 'Tilgængelighed',
      security: 'Sikkerhed'
    },
    type: {
      haNetsvcFailedOver: 'Failover af netværkstjenesten',
      haNetsvcNoCandidate: 'Netværkstjeneste uden kandidatnode',
      haNetsvcReaped: 'Lokal instans høstet ved gentilslutning',
      netsvcFloatipMoved: 'Flydende IP flyttet til en anden holder',
      netsvcFloatipNoHolder: 'Flydende IP uden sundt mål',
      haAppFailedOver: 'App-instans failet over',
      haAppNoCandidate: 'App-instans uden kandidatnode',
      haAppStorageLocalSkip: 'App-instans ikke flyttet: persistente data er lokale på den døde node',
      haAppReaped: 'App-instansens lokale pod høstet ved genindtræden'
    }
  },
  audit: {
    loadError: 'Auditregistret kunne ikke indlæses — er TVirt-backenden tilgængelig?',
    title: 'Audit',
    subtitle: 'Hvem gjorde hvad, hvornår og på hvilket objekt — forsøgte handlinger, afvisninger inklusive',
    filterOutcome: 'Udfald',
    filterAll: 'Alle',
    filterSudo: 'Kun forhøjede handlinger',
    colAt: 'Hvornår',
    colActor: 'Hvem',
    colAction: 'Handling',
    colTarget: 'Objekt',
    colOutcome: 'Udfald',
    colNode: 'Node',
    empty: 'Ingen registrerede handlinger',
    loadMore: 'Indlæs flere',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rute',
    detailProblem: 'Årsag',
    detailTask: 'Task',
    detailClientIp: 'Fra',
    detailId: 'Post-ID',
    detailSession: 'Session',
    taskHint: 'Udfaldet af en accepteret handling lever i hændelsesjournalen, under samme task-id',
    outcome: {
      succeeded: 'Udført',
      accepted: 'Accepteret',
      denied: 'Nægtet',
      rejected: 'Afvist',
      failed: 'Fejlet'
    }
  },
  notifications: {
    loadError: 'Notifikationerne kunne ikke indlæses — er TVirt-backenden tilgængelig?',
    actionError: 'Handlingen blev afvist',
    title: 'Notifikationer',
    subtitle: 'De destinationer, som journalens fakta forlader klyngen til',
    rulesTitle: 'Regler',
    rulesSubtitle: 'Hvilke fakta der går ud, og hvorhen',
    deliveriesTitle: 'Leveringer',
    deliveriesSubtitle: 'Resultatet af hver notifikation, med årsagen når den fejler',
    colName: 'Navn',
    colKind: 'Type',
    colWhere: 'Hvorhen',
    colScope: 'Scope',
    colSeverity: 'Alvorlighed',
    colMatch: 'Filter',
    colTargets: 'Destination',
    colAt: 'Hvornår',
    colState: 'Tilstand',
    colEvent: 'Hændelse',
    colAttempts: 'Forsøg',
    colOutcome: 'Resultat',
    empty: 'Ingen række',
    matchAll: 'alle fakta',
    test: 'Test',
    testOk: 'Testnotifikation leveret til {target}',
    testFailed: 'Test til {target} mislykkedes: {reason}',
    retry: 'Læg i kø igen',
    retried: 'Levering lagt i kø igen',
    grouped: 'og {count} yderligere gentagelser',
    state: {
      failed: 'Mislykket',
      pending: 'I kø',
      sending: 'Sendes',
      sent: 'Sendt'
    },
    tabTargets: 'Destinationer',
    tabRules: 'Regler',
    tabDeliveries: 'Leveringer',
    targetCreateTitle: 'Ny destination',
    ruleCreateTitle: 'Ny regel',
    nameHint: 'Små bogstaver, cifre og bindestreger; unikt pr. scope',
    kindImmutableHint: 'Uforanderlig: at skifte type betyder at oprette en anden destination',
    kindSmtp: 'Post (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Status',
    enabledOn: 'Aktiv',
    enabledOff: 'Sat på pause',
    smtpHost: 'SMTP-server',
    smtpPort: 'Port',
    smtpPortHint: 'Sædvanligt: 25 uden TLS, 587 med starttls, 465 med tls',
    smtpSecurity: 'Sikkerhed',
    smtpFrom: 'Afsender',
    smtpTo: 'Modtagere',
    smtpToHint: 'En eller flere adresser adskilt af komma',
    webhookUrl: 'URL',
    payload: 'Indhold',
    payloadHint: 'Med minimal forlader hændelsens besked og data aldrig klyngen',
    credential: 'Legitimationsoplysning',
    credentialNone: 'Ingen',
    credentialHintSmtp: 'Relay-kontoen fra nøglelageret; ingen betyder anonym SMTP',
    credentialHintWebhook: "Signeringshemmeligheden fra nøglelageret; uden signering kan enhver, der kender URL'en, udgive sig for klyngen",
    minSeverityHint: 'En tærskel, ikke en mængde: fra denne alvorsgrad og op',
    categories: 'Kategorier',
    categoriesHint: 'Tomt = alle',
    types: 'Hændelsestyper',
    typesHint: 'Adskilt af komma; tomt = alle. En ukendt type afvises',
    targetsHint: 'Mindst én; de skal ligge i reglens scope eller i en forfader til det',
    recursiveOn: 'Også underordnede scope',
    recursiveOff: 'Kun dette scope',
    recursiveHint: 'Ressourcer lever i bladene: uden børnene varsler en regel på roden næsten intet',
    repeatWindow: 'Grupperingsvindue (s)',
    repeatWindowHint: 'Inden for vinduet sender gentagelser ingen post: de tælles på den første. 0 slår fra',
    targetInUseError: 'Destinationen {name} bruges stadig af en regel'
  }
}
